import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { HhgRatesCsvDownload } from 'src/app/features/hhg-rates-csv-download/hhgRatesCsvDownload';
@Injectable({
  providedIn: 'root'
})
export class FrtRatesCsvDownloadService extends DataService  {

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * @param: controlId,carrierId,SRO list,Origin id, Destination id
   */
  exportDataFromServer(ratesPoc: HhgRatesCsvDownload): any {
    return this.http.post(this.apiUri + '/ratesfrt/downloadFrtRates/csv/', ratesPoc);
  }
}
